@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    <div formArrayName="rowOpbrengsten">
      @for (item of rowOpbrengsten.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving opbrengsten' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving-' + i"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              [required]=true
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="bedragRow-' + i"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijRowOpbrengsten(i)"
                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                 class="col-auto"
                                 icon="trash"
                                 id="buttonDeleteKosten-' + i"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>

    <snelstart-ui-button (click)="addRijOpbrengsten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Opbrengsten toevoegen
    </snelstart-ui-button>

    <div formArrayName="rowKosten">
      @for (item of rowKosten.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving kosten' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving-' + i"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="kosten-' + i"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijRowKosten(i)"
                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                 class="col-auto"
                                 icon="trash"
                                 size="medium"
                                 type="secondary"
                                 id="delete-' + i"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
    <snelstart-ui-button (click)="addRijKosten()" class="snelstart-ui-button" icon="plus"
                         type="link">Kosten toevoegen
    </snelstart-ui-button>
  </form>
}
